
import Component, { mixins } from "vue-class-component"
import Calculator from "../mixins/Calculator.vue"
import ErrorBox from "../custom/ErrorBox.vue"
import FilialeHeader from "../custom/FilialeHeader.vue"
import NichtGueltig from "../custom/NichtGueltig.vue"
import StandortLieferungLogic from "@/logic/bestellung_neu/standort_lieferung_logic"

@Component({ components: { ErrorBox, FilialeHeader, NichtGueltig } })
export default class StandortLieferung extends mixins(Calculator) {
  logic: StandortLieferungLogic = new StandortLieferungLogic()

  mounted() {
    this.logic.init()
  }

  standortErmitteln() {
    this.logic.positionErmitteln(navigator)
  }

  weiter() {
    this.logic.weiter()
  }

  weiterDirekt() {
    this.logic.weiterDirekt()
  }

  standortBearbeiten() {
    this.logic.standortBearbeiten()
  }
}
